
import { useState } from 'react';
import { createStore } from 'reusable';

export const useNavTab = createStore(() => useState('wi-fi'));
